var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"label":"","color":_vm.chipColor}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.chipIcon))]),_vm._v(" "+_vm._s(_vm.chipStatus)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }